import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addPopup } from 'redux/actions';
import * as popups from 'constants/popup-types';
import { TextHot } from 'components/common/TextHot';
import { ButtonHot } from 'components/common/ButtonHot';

export const HotYoterGuestSection = ({
    message,
    buttonLabel,
    testID = 'hot-yoter-guest-section',
}) => {
    const dispatch = useDispatch();
    const translations = useSelector((store) => store.config.Translations);

    if (!message && !buttonLabel) {
        return null;
    }

    const handleLogin = () => {
        dispatch(
            addPopup({
                type: popups.LOGIN,
                subtitleText: translations?.login_share_title,
            }),
        );
    };

    return (
        <section className="hot-yoter-guest-section" testId={testID} dir="rtl">
            <div className="hot-yoter-guest-section__inner">
                {message ? (
                    <TextHot
                        size="m"
                        component="p"
                        className="hot-yoter-guest-section__message"
                        sx={{ m: 0, color: '#000', direction: 'rtl' }}
                        testID={`${testID}-message`}
                    >
                        {message}
                    </TextHot>
                ) : null}
                {buttonLabel ? (
                    <ButtonHot
                        testID={`${testID}-login-button`}
                        className="hot-yoter-guest-section__button"
                        size="m"
                        onClick={handleLogin}
                    >
                        {buttonLabel}
                    </ButtonHot>
                ) : null}
            </div>
        </section>
    );
};
